import styled from "styled-components";

export const OurCasesTitle = styled.h2`
    font-weight: 700;
    font-size: 79px;
    margin-bottom: 74px;
    line-height: 1;
    position: relative;
    z-index: 1;

    @media (max-width: 1199px) {
        font-size: 60px;
        margin-bottom: 64px;
    }
    @media (max-width: 599px) {
        font-size: 50px;
        margin-bottom: 34px;
    }
`;

export const SectionOurCases = styled.section`
    padding-bottom: 150px;
    position: relative;
    & > * {
        grid-column: 1 / -1;
    }
    padding-left: 125px;
    padding-right: 125px;
    padding-top: 20px;
    display: grid;
    grid-gap: 20px 0;
    grid-template-columns: 20px 1fr 20px;
    align-content: start;

    @media (max-width: 1199px) {
        padding-top: 0px;
        max-width: 1024px;
        padding-left: 25px;
        padding-right: 25px;
    }
`;

export const Scroller = styled.div`
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-auto-flow: column;

    @media (max-width: 1199px) {
        grid-template-columns: 100%;
        grid-template-rows: 150px 150px 150px 150px 150px 150px;
        grid-auto-flow: row;
    }
`;

export const CaseStudy = styled.a`
    dscroll-snap-align: center;
    padding: calc(20px / 2 * 1.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #2770d8;
    border-radius: 40px;
    object-fit: cover;

    @media (max-width: 1199px) {
        padding: 50px;
    }
`;
